// extracted by mini-css-extract-plugin
export default {"host":"style_host__ZNJny","buttons":"style_buttons__l5Ej-"};